export const getHost = function() {
    const {protocol} = window.location;
    const slashes = protocol.concat("//");
    const host = slashes.concat(`${window.location.hostname}/`);
    return host;
}

export const redirectTo = function(param = '') {
    window.location.href = getHost() + param;
}